export const SectionHeading = ({ eyebrow, title, sub, align = 'left', light = false, className = '' }) => {
    const textColor = light ? 'text-white' : 'text-navy';
    const subColor = light ? 'text-white/70' : 'text-ink/70';
    const alignClass = align === 'center' ? 'text-center mx-auto' : '';
    return (
        <div className={`max-w-3xl ${alignClass} ${className}`}>
            {eyebrow && <div className="eyebrow mb-5">{eyebrow}</div>}
            {title && (
                <h2 className={`editorial-h2 text-3xl md:text-5xl ${textColor}`}>
                    {title}
                </h2>
            )}
            {sub && <p className={`mt-6 text-base md:text-lg ${subColor} leading-relaxed`}>{sub}</p>}
        </div>
    );
};

export const PageHero = ({ eyebrow, title, sub, image, overlay = 0.45 }) => (
    <section
        data-testid="page-hero"
        className="relative pt-40 pb-24 md:pt-48 md:pb-32 overflow-hidden bg-navy-deep"
    >
        {image && (
            <div className="absolute inset-0">
                <img src={image} alt="" className="w-full h-full object-cover" />
                <div className="absolute inset-0" style={{ backgroundColor: `rgba(7, 18, 36, ${overlay})` }} />
                <div className="absolute inset-y-0 left-0 w-3/5 bg-gradient-to-r from-navy-deep/85 via-navy-deep/40 to-transparent" />
            </div>
        )}
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
            {eyebrow && <div className="eyebrow text-gold mb-6">{eyebrow}</div>}
            <h1 className="editorial-h1 text-4xl sm:text-5xl lg:text-6xl text-white max-w-4xl">
                {title}
            </h1>
            {sub && (
                <p className="mt-8 text-white/75 text-base md:text-lg leading-relaxed max-w-2xl">
                    {sub}
                </p>
            )}
            <div className="mt-10 h-px w-24 bg-gold" />
        </div>
    </section>
);
